import React, { useEffect } from 'react';
import axios from 'axios';
import { Resource, ResourceInfo } from 'omni-package-react-core';
import { useScopedSelector } from 'ia-react-core';
import getAppPath from '~/utils/getAppPath';
import { reloadPage } from '~/utils/browserNavigation';
import { Versioning } from '~/interfaces/Versioning';

export const ApplicationVersioningResourceInfo: ResourceInfo = {
  name: '/App.VersioningResource',
  url: `${getAppPath()}version.json`,
  dataDst: '/App.Versioning',
};

let initialVersion: string | null = null;
let versionCheckPromise: Promise<void> | null = null;

const getVersionUrl = (): string => `${getAppPath()}version.json`;

const fetchCurrentVersion = async (): Promise<string | null> => {
  try {
    const response = await axios.get<Versioning>(getVersionUrl());
    return response?.data?.version ?? null;
  } catch {
    return null;
  }
};

export const checkVersionAndReload = (): Promise<void> => {
  if (!initialVersion) {
    return Promise.resolve();
  }

  if (versionCheckPromise !== null) {
    return versionCheckPromise;
  }

  versionCheckPromise = fetchCurrentVersion()
    .then((currentVersion) => {
      if (currentVersion && currentVersion !== initialVersion) {
        reloadPage();
      }
    })
    .finally(() => {
      versionCheckPromise = null;
    });

  return versionCheckPromise;
};

export const resetVersionCheckStateForTests = (): void => {
  initialVersion = null;
  versionCheckPromise = null;
};

const ApplicationVersioningResource = () => {
  const initial: Versioning = useScopedSelector(ApplicationVersioningResourceInfo.dataDst);

  useEffect(() => {
    if (initial?.version) {
      initialVersion = initial.version;
    }
  }, [initial?.version]);

  return (
    <Resource
      {...ApplicationVersioningResourceInfo}
      autoRequestIfEmpty
    />
  );
};

export default ApplicationVersioningResource;
